import {
  Component, Input, Output, EventEmitter,
  ViewChild, ElementRef,
} from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'simple-pagination',
  templateUrl: 'simple-pagination.component.html',
  styleUrls: ['simple-pagination.component.scss'],
})
export class SimplePaginationComponent {
  @Input() currentPage: number;
  @Input() lastPage: number;
  @Input() isPageInput: boolean = false;

  @ViewChild('pageInput', {static: false}) input: ElementRef | void;

  @Output() paginationBtnClick = new EventEmitter<number>();
  @Output() currPageChanged = new EventEmitter<number>();

  get isPrevDisabled(): boolean {
    return this.currentPage === 1;
  }

  get isNextDisabled(): boolean {
    return this.currentPage >= this.lastPage;
  }

  onPaginationBtnClick(event: MouseEvent, direction: number) {
    event.preventDefault();
    if (direction === 1 && this.isNextDisabled) { return; }
    if (direction === -1 && this.isPrevDisabled) { return; }
    this.paginationBtnClick.emit(direction);
  }

  onInputEnterKeyup() {
    let currVal;
    if (!this.input) {
      return;
    }
    try {
      currVal = Number(this.input.nativeElement.value);
    } catch (e) {
      console.log(e);
    }
    if (currVal > 0 && currVal <= this.lastPage) {
      this.currentPage = this.input.nativeElement.value;
      this.currPageChanged.emit(this.currentPage);
    } else {
      this.input.nativeElement.value = this.currentPage;
    }
    this.input.nativeElement.blur();
  }

  onInputBlur() {
    if (!this.input) {
      return;
    }
    this.input.nativeElement.value = this.currentPage;
  }
}
